var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightIcon = function SvgChevronRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.786 12.043 9.26 16.73a.72.72 0 0 1-1.045 0 .784.784 0 0 1 0-1.081l4.05-4.195-4.05-4.195a.784.784 0 0 1 0-1.08.72.72 0 0 1 1.045 0l4.525 4.685c.13.136.214.31.214.566 0 .26-.08.474-.214.614",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRightIcon;